export default {
  wrapper: {
    base: {
      p: 'base',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderColor: 'grey-20',
      variant: 'spark.base.wrapper'
    }
  },
  top: {
    base: {
      mb: 'base',
      mt: '-base',
      mx: '-base'
    }
  },
  bottom: {
    base: {
      mt: 'base',
      mb: '-base',
      mx: '-base'
    }
  }
};